export default __webpack_public_path__ + "static/media/puzzle.5bf02aec.svg";